import api from "../../../api/axios";

const exportJongerenExcel = async (schoolYearId) => {
  const response = await api.post(
    "/api/v1/power/excel-export/jongeren",
    { schoolYearId },
    {
      responseType: "blob",
    },
  );

  return response;
};

const excelExportService = {
  exportJongerenExcel,
};

export default excelExportService;
